import ACTIONS from 'state/constants';
import { getCurrentSize, getCurrentProductHandle } from 'state/selectors/pdp';
import { replaceHistory, parseQueryString } from 'utils/Url';

const PdpUrlUpdater = store => next => action => {
  next(action);

  // Update URL
  const state = store.getState();
  const productSize = getCurrentSize(state);
  const productHandle = getCurrentProductHandle(state);

  if (
    productHandle &&
    (action.type === ACTIONS.SET_CURRENT_PRODUCT || action.type === ACTIONS.SET_CURRENT_SIZE)
  ) {
    const currentParams = parseQueryString();

    replaceHistory({ ...currentParams, size: productSize }, null, `/products/${productHandle}`);
  }
};

export default PdpUrlUpdater;
